module.exports = __webpack_public_path__ + "images/anwbpersonenhulp_small4daa77d273b538d335b3617653ded92e.png";